import { render, staticRenderFns } from "./Nouveau.vue?vue&type=template&id=80073982"
import script from "./Nouveau.vue?vue&type=script&lang=js"
export * from "./Nouveau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports